import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'empty-property-card',
  standalone: false,
  templateUrl: './empty-property-card.component.html',
  styleUrl: './empty-property-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyPropertyCardComponent {

}
